import { MobileAppBanner } from './MobileAppBanner';
import PopularServices from './PopularServices';

const PreLoginDashboard = () => (
  <>
    <MobileAppBanner />
    <PopularServices />
  </>
);

export default PreLoginDashboard;
